export class MissingStoreDependencyError extends Error {
  constructor(storeName: string, message: string) {
    super(message);
    this.name = `${storeName}:MissingStoreDependencyError`;
  }
}
